var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgItems(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "700.000000pt",
    height: "560.000000pt",
    viewBox: "0 0 700.000000 560.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,560.000000) scale(0.100000,-0.100000)",
    fill: "#6ed0a1",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2480 5508 c-282 -22 -557 -217 -681 -482 -49 -104 -70 -191 -76 -316 -15 -308 121 -577 377 -749 155 -104 324 -149 518 -138 219 12 401 96 553 254 181 187 258 405 237 674 -22 293 -230 578 -508 694 -136 57 -260 76 -420 63z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4355 5509 c-361 -29 -667 -298 -749 -659 -21 -91 -22 -263 -2 -358 51 -244 227 -473 451 -585 201 -100 455 -114 669 -36 285 104 498 362 546 662 19 115 8 271 -25 377 -51 159 -116 262 -244 382 -170 160 -397 236 -646 217z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2423 3636 c-149 -29 -275 -86 -391 -179 -128 -101 -236 -265 -284 -433 -33 -114 -33 -334 0 -448 84 -292 315 -520 607 -597 109 -29 298 -32 405 -5 387 96 651 431 651 826 0 283 -135 542 -364 699 -69 47 -200 106 -280 125 -94 23 -255 29 -344 12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4305 3640 c-414 -65 -716 -420 -716 -840 0 -387 239 -702 618 -816 119 -36 315 -39 438 -6 292 79 523 306 607 599 33 113 33 333 0 447 -104 360 -416 606 -787 621 -55 2 -127 0 -160 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2400 1766 c-93 -20 -215 -69 -290 -118 -83 -54 -204 -175 -258 -258 -179 -276 -174 -657 11 -930 46 -67 154 -177 217 -220 160 -108 298 -151 495 -151 232 1 435 87 600 256 313 321 317 838 10 1163 -117 124 -214 186 -375 237 -70 22 -108 28 -215 31 -85 2 -152 -1 -195 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4287 1770 c-253 -43 -493 -222 -607 -453 -68 -138 -91 -232 -91 -378 0 -244 85 -449 256 -614 319 -310 837 -317 1156 -17 179 168 265 350 276 582 12 256 -69 463 -252 646 -122 122 -265 197 -433 230 -79 15 -227 17 -305 4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItems);
export default __webpack_public_path__ + "static/media/items.fe85447ebb14d4b5e5417748aa42b424.svg";
export { ForwardRef as ReactComponent };